import { DependencyList, useEffect } from "react";

type ResizeCallback = (width: number, height: number) => void;

/**
 * Add a callback to the winodw resize event.
 * `callback` must be a `React.useCallback`
 * @param callback Function to call when the window resizes
 * @param callImmediate Immediately execute when React is ready
 * @param deps Resize only when dependencies change
 */
export default function useResize(callback: ResizeCallback, callImmediate: boolean = false, deps: DependencyList = []) {
    useEffect(() => {
        function cb() {
            callback(window.innerWidth, window.innerHeight);
        }
        window.addEventListener("resize", cb);
        if (callImmediate) cb();
        return () => {
            window.removeEventListener("resize", cb);
        }
    }, [callback, callImmediate, ...deps]); // eslint-disable-line react-hooks/exhaustive-deps
}